/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: metanav.js
 */

(function(scsHeader, $, SCS) {
	'use strict';

	$.namespace('scsHeader.metanav');

	function updateLegacyHeader() {
		// Read number of cart items from cookie and add it to shopping cart link
		var cartItems = window.Tc && window.Tc.Module.Basket && window.Tc.Module.Basket.getNumberOfItemsInBasket();
		if (cartItems > 0) {
			if (!$('#shoppingCartLink .cart-itemcount').length) {
				$('#shoppingCartLink').prepend('<span class="cart-itemcount">' + cartItems + '</span>');
			} else {
				$('#shoppingCartLink .cart-itemcount').text(cartItems);
			}
		} else {
			$('#shoppingCartLink .cart-itemcount').remove();
		}
	}
	function updateResponsiveHeader($modBasket) {
		var basket = window.application.sandbox.getModuleInstance($modBasket, 'Basket');
		if(basket) {
			basket.updateBasketNumberIndicator();
		}
	}

	scsHeader.metanav.updateShoppingCartItemsIcon = function() {
		var $modBasket = $('.modHeader .modBasket');
		if($modBasket.length) {
			updateResponsiveHeader($modBasket);
		} else {
			updateLegacyHeader();
		}
	};

	scsHeader.metanav.initShoppingCartMini = function() {
		if (!$('#cartmini').length || !$('#shoppingCartLink-wrap').length) {
			return;
		}
		var shoppingCartMiniIsOpen = false;
		$('#shoppingCartLink-wrap').append('<div id="cartmini-top"></div><span></span>')
			.append($('#cartmini'));
		$('#shoppingCartLink').addClass('active');
		var shoppingCartHref = $('#shoppingCartLink').attr('href');
		$('#shoppingCartLink').attr('href', 'javascript:void(0)');
		$('#cartmini-cartlink').attr('href', shoppingCartHref);
		var url = $('#cartmini').data('url');

		$('body').on('click', function(e) {
			if (!shoppingCartMiniIsOpen || $(e.target).parents('#shoppingCartLink-wrap').length
				|| $(e.target).is('#shoppingCartLink-wrap')) {
				return;
			}
			$('#shoppingCartLink').trigger('click');
		});

		$('#shoppingCartLink').click(function() {
			scsHeader.metanav.updateShoppingCartItemsIcon();

			var $this = $(this);
			var parent = $this.parents('#shoppingCartLink-wrap');
			shoppingCartMiniIsOpen = !parent.is('.open');
			parent[shoppingCartMiniIsOpen ? 'addClass' : 'removeClass']('open');
			if (!shoppingCartMiniIsOpen) {
				return;
			}
			$.ajax({
				type : 'GET',
				url : url,
				dataType : 'json',
				success : function(json) {
					var i, j;
					var $cartMiniWrapper = $('#cartmini .scs-cartmini-inner');
					$('#cartmini .scs-loadingRotator, .scs-cartmini-error, .scs-cartmini-empty')
						.hide();
					$('.scs-cartmini-inner tbody').remove();

					// error text
					var errorText = '';
					if (json && json.ErrorMessages && json.ErrorMessages.length) {
						for (i = 0; i < json.ErrorMessages.length; i+=1) {
							errorText += '<p>' + json.ErrorMessages[i] + '</p>';
						}
						$('.scs-cartmini-error').html(errorText).show();
					}

					if (json && json.BasketItems && json.BasketItems.length) {
						$('.basket-total td.onetimecharge')
							.html(json.OneTimeChargeFormatted);
						$('.basket-total td.recurringcharge')
							.html(json.RecurringChargeFormatted);

						// cart items
						for (i = 0; i < json.BasketItems.length; i+=1) {
							var groupItems = (json.BasketItems[i].ChildrenItems) ? json.BasketItems[i].ChildrenItems.length + 1
								: 1;
							var groupClass = (i == json.BasketItems.length - 1) ? 'basket-item-group basket-item-group-last'
								: 'basket-item-group';
							var itemHtml = '<tbody class="' + groupClass + '">';
							for (j = 0; j < groupItems; j+=1) {
								var basketItem = (j == 0) ? json.BasketItems[i]
									: json.BasketItems[i].ChildrenItems[j - 1];
								var itemClass = (j == groupItems - 1) ? 'basket-item basket-item-last'
									: 'basket-item';
								if (j == 0) {
									itemClass += ' basket-item-first';
								}
								if (basketItem.IsPromo) {
									itemClass += ' basket-item-promo';
									basketItem.ProductName = '<span class="promo-bullet">+ </span><span class="promo-bullet-text">'
										+ basketItem.ProductName + '</span>';
								}
								// if (basketItem.ErrorMessages &&
								// basketItem.ErrorMessages.length)
								// itemClass += "
								// basket-item-error";

								itemHtml += '<tr class="' + itemClass + '">';

								itemHtml += '<input type="hidden" name="ProductId" value="'
									+ basketItem.ProductId
									+ '" class="basket-item-hiddenid">';
								if (j == 0) {
									itemHtml += '<td rowspan="' + groupItems
										+ '" class="basket-item-image">' + '<img alt="'
										+ basketItem.ProductName + '" src="'
										+ basketItem.ImagePathMini + '">' + '</td>';
								}
								var basketItemQuantity = (basketItem.Quantity > 1) ? basketItem.Quantity
									+ 'x '
									: '';
								if (basketItem.OneTimeCharge == 0) {
									basketItem.OneTimeChargeFormatted = '';
								}
								itemHtml += '<td class="basket-item-text">'
									+ basketItemQuantity
									+ basketItem.ProductName
									+ '</td>'
									+ '<td class="basket-item-separatorrow"></td>'
									+ '<td class="recurringcharge">'
									+ ((basketItem.RecurringCharge) ? basketItem.RecurringChargeFormatted
										: '')
									+ '</td>'
									+ '<td class="onetimecharge">'
									+ ((basketItem.IsPromo && basketItem.OneTimeCharge == 0) ? SCS.portal.i18n.freeOfCharge
										: basketItem.OneTimeChargeFormatted) + '</td>';
								itemHtml += '</tr>';
							}
							itemHtml += '</tbody>';
							$('.scs-cartmini-inner table tfoot.basket-total')
								.before(itemHtml);
							$cartMiniWrapper.show();
						}
					} else {
						// empty cart
						$('.scs-cartmini-empty').show();
						$('.scs-cartmini-inner, .scs-cartmini-error, .scs-cartmini .scs-loadingRotator')
							.hide();
						$('#shoppingCartLink .cart-itemcount').remove();
					}
				}
			});
		});
	};

	/**
	 * Initialize meta navigation
	 */
	$(function() {
		// language selector
		var langIsOpen = false;
		// move active language outside the ul/li construct
		$('#scs-pageheader-language-switch li.active, #scs-pageheader-language-switch li a.active, #scs-pageheader-language-switch li.scsh-active, #scs-pageheader-language-switch li a.scsh-active')
			.each(function() {
				var $this = $(this);
				var activeLang = $this.text();
				var ul = $this.closest('ul');
				var languages = $('#scs-pageheader-language-switch li').length;
				if (languages > 1) {
					ul.before('<a href="javascript:void(0)" class="active scsh-active">' + activeLang + '</a>');
				} else {
					// single language pages do not need a language selector
					ul.before(activeLang);
				}
				if (this.tagName.toLowerCase() == 'a') {
					$this = $this.closest('li');
				}
				$this.remove();
			});
		// click event for active language
		$('#scs-pageheader-language-switch a.active, #scs-pageheader-language-switch a.scsh-active').on('click', function(e) {
			var parent = $('#scs-pageheader-language-switch');
			langIsOpen = !parent.is('.open');
			parent.toggleClass('open', langIsOpen);
			e.preventDefault();
		});
		// close languageSelector if something outside is clicked
		$('body').on('click', function(e) {
			if (!langIsOpen || $(e.target).parents('#scs-pageheader-language-switch').length
				|| $(e.target).is('#scs-pageheader-language-switch')) {
				return;
			}
			$('#scs-pageheader-language-switch a.active, #scs-pageheader-language-switch a.scsh-active').trigger('click');
		});

		// replace date placeholder with current date
		$('.scs-pageheader-metanav-date').html(window.scsHeaderDateFormat(new Date(), 'dd.mm.yyyy'));

		// init JUNCTION SWITCH, for example BUSINESS AREA SELECTOR
		var junctionSwitchIsOpen = false;
		$('#scs-pageheader-junction-switch-selector a.active').on('click', function(e) {
			var dropdown = $('#scs-pageheader-junction-switch-dropdown');
			var selector = $('#scs-pageheader-junction-switch-selector');
			junctionSwitchIsOpen = !dropdown.is('.open');
			dropdown.toggleClass('open', junctionSwitchIsOpen);
			selector.toggleClass('open', junctionSwitchIsOpen);
			e.preventDefault();
		});
		$('body').on('click', function(e) {
			if (!junctionSwitchIsOpen
				|| $(e.target).parents('#scs-pageheader-junction-switch-selector').length
				|| $(e.target).is('#scs-pageheader-junction-switch-selector')) {
				return;
			}
			$('#scs-pageheader-junction-switch-selector a.active').trigger('click');
		});
		$('#scs-pageheader-junction-switch-dropdown').on('click', function(e) {
			e.stopPropagation(); // do not propagate this click event to parents
									// -> prevents closing
		});

		scsHeader.metanav.updateShoppingCartItemsIcon();
		scsHeader.metanav.initShoppingCartMini();

		// Write the resume shopping link cookie on Shopping cart link click (FR
		// 14608)
		$('#shoppingCartLink').click(function() {
			$.cookie('SCSResumeShoppingLink', window.location.href, {
				'path' : '/'
			});
		});

	});

})(window.scsHeader, window.scsHeaderJQuery, window.SCS);



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/header/clientlibs/desktop/js/metanav.js
// module id = 102
// module chunks = 0